<template>
  <div class="modal-out">
    <div class="modal">

      <div class="modal-header">
        <div class="title">课程</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>

      <div class="modal-body" style="padding: 10px;">

        <div style="height: 10px;"></div>

        <el-table class="table" size="mini" :data="tableData" border :height="300">
          <el-table-column label="标题" prop="title" width="100"></el-table-column>
          <el-table-column label="排序" prop="sort"></el-table-column>
          <el-table-column label="视频">
            <template slot-scope="scope">
              <video v-if="scope.row.videoUrl" :src="imgUrl+ scope.row.videoUrl" style="width: 100px;height: 100px;"/>
            </template>

          </el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click.native.prevent="handleEdit(scope.$index, scope.row)">编辑</el-button>
              <el-button type="text" size="mini" @click.native.prevent="handleDelete(scope.$index, scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>


      </div>
      <div class="modal-footer">
        <el-button @click="closeSelf">取消</el-button>
        <el-button :loading="loading" type="primary" @click="toggleModalCourseAdd()">添加课程</el-button>
      </div>

    </div>


    <CourseAdd ref="myCourseAdd" v-show="showModalCourseAdd" v-on:closeCourseAdd="closeCourseAdd" v-on:getList="getList"></CourseAdd>

    <CourseEdit ref="myCourseEdit" v-show="showModalCourseEdit" v-on:closeCourseEdit="closeCourseEdit" v-on:getList="getList"></CourseEdit>

  </div>
</template>

<script>

import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";


import CourseEdit from "./CourseEdit";
import CourseAdd from "./CourseAdd";


export default {
  name: 'Elderly',
  data() {
    return {

      loading: false,

      showModalCourseAdd:false,
      showModalCourseEdit:false,

      trainCode:'',

      tableData:[],
      totalItems:0,
      pageSize: 20,
      currentPage: 1,

      imgUrl:this.$imgUrl,

      th:this.$store.state.tableHeight,
    }
  },
  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th=val
    },
  },
  components:{
    CourseAdd,CourseEdit
  },
  methods: {
    init(row){
      this.trainCode = row.trainCode;
      this.getList();
    },

    closeSelf() {
      this.$emit("closeEditCourse");
    },



    toggleModalCourseAdd:function(){
      this.showModalCourseAdd = !this.showModalCourseAdd;
      this.$refs.myCourseAdd.init(this.trainCode);
    },
    closeCourseAdd:function(){
      this.showModalCourseAdd = !this.showModalCourseAdd;
    },


    handleEdit:function(index,row){
      this.showModalCourseEdit = !this.showModalCourseEdit;
      this.$refs.myCourseEdit.init(row);
    },
    closeCourseEdit:function(){
      this.showModalCourseEdit = !this.showModalCourseEdit;
    },


    handleDelete(index,row){

      this.$confirm("您确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {

        this.$axios({
          method: "post",
          url: this.$shopUrl + "TrainCourse/Delete",
          data: {
            timeStr: timeStr,
            sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
            staffCode:getStaffCode(),
            trainCourseCode: row.trainCourseCode,
          },
        }).then((response) => {
          //console.log(response);
          if (response.data.error == 0) {
            //this.$message({message: "解绑成功", type: "success",});
            this.getList();
          } else if (response.data.error == 1) {
            this.$message.error(response.data.message);
          }
        }).catch(function (error) {
          console.log(error);
        });

      }).catch(() => {
        //this.$message({type: "info", message: "已取消操作",});
      });


    },




    getList(){
      this.loading = true;
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"TrainCourse/List",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          trainCode:this.trainCode,
        }
      }).then((response) => {
            this.loading = false;
            if (response.data.error == 0) {
              this.tableData=response.data.data.list;
            }else if(response.data.error == 1){
              this.$message.error(response.data.message)
            }
          })
    },

  }
}


</script>

<style lang="scss" scoped>

</style>
